import { useReservedStock } from '@/services/api/hooks/stock/reservedStock';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useSelectedProducts } from '../useCustomerCatalogueService';
import { useBundleStockLevels } from './useBundleStockLevels';
import { StockBinLevel } from './useDefaultBundleStockLevels';
import { useGeneralStockLevels } from './useGeneralStockLevels';

export const useSummaryStockLevels = () => {
  const generalStockLevels = useGeneralStockLevels();
  const bundleStockLevels = useBundleStockLevels();
  const bundledProducts = useSelectedProducts();

  const { partnerId, companyId } = useParams();
  if (!(partnerId && companyId)) throw new Error('Missing params');

  const [reservedStock] = useReservedStock(partnerId, companyId);

  return useMemo(() => {
    const stockLevels: StockBinLevel[] = bundledProducts.map(product => {
      const generalStock = generalStockLevels.find(g => g.product.id === product.id);
      const bundleStock = bundleStockLevels.find(b => b.product.id === product.id);
      const inStock = reservedStock.find(s => s.daasCatalogItemId === product.id);

      return {
        product,
        reservedStock: inStock?.stockLevel ?? 0,
        maxStockLevel: (generalStock?.maxStockLevel ?? 0) + (bundleStock?.maxStockLevel ?? 0),
        minStockLevel: (generalStock?.minStockLevel ?? 0) + (bundleStock?.minStockLevel ?? 0)
      };
    });

    return stockLevels;
  }, [bundledProducts]);
};
